(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bindWindowDrag(layer, win, bar) {
    if (!layer || !win || !bar) return { reset: function () {} };

    let dragging = false;
    let moved = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let winStartLeft = 0;
    let winStartTop = 0;

    function reset() {
      win.style.position = '';
      win.style.left = '';
      win.style.top = '';
      win.style.right = '';
      win.style.bottom = '';
      win.style.margin = '';
      win.style.transform = '';
      win.style.zIndex = '';
    }

    function clamp(left, top) {
      const rect = win.getBoundingClientRect();
      const maxLeft = Math.max(0, window.innerWidth - rect.width);
      const maxTop = Math.max(0, window.innerHeight - 36);
      return {
        left: Math.min(Math.max(0, left), maxLeft),
        top: Math.min(Math.max(0, top), maxTop)
      };
    }

    function onMove(event) {
      if (!dragging) return;
      const next = clamp(
        winStartLeft + event.clientX - dragStartX,
        winStartTop + event.clientY - dragStartY
      );
      if (Math.abs(event.clientX - dragStartX) > 3 || Math.abs(event.clientY - dragStartY) > 3) {
        moved = true;
      }
      win.style.left = next.left + 'px';
      win.style.top = next.top + 'px';
    }

    function onEnd(event) {
      if (!dragging) return;
      dragging = false;
      layer.classList.remove('is-dragging');
      if (event && bar.hasPointerCapture && bar.hasPointerCapture(event.pointerId)) {
        bar.releasePointerCapture(event.pointerId);
      }
    }

    bar.addEventListener('pointerdown', function (event) {
      if (event.button && event.button !== 0) return;
      if (
        event.target.closest(
          'a, button, input, textarea, select, [data-ch-doc-close], [data-ch-dossier-close], [data-ch-player-close]'
        )
      ) {
        return;
      }
      const rect = win.getBoundingClientRect();
      win.style.position = 'absolute';
      win.style.left = rect.left + 'px';
      win.style.top = rect.top + 'px';
      win.style.right = 'auto';
      win.style.bottom = 'auto';
      win.style.margin = '0';
      win.style.transform = 'none';
      win.style.zIndex = String(Date.now());
      dragging = true;
      moved = false;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      winStartLeft = rect.left;
      winStartTop = rect.top;
      layer.classList.add('is-dragging');
      if (bar.setPointerCapture) bar.setPointerCapture(event.pointerId);
    });

    bar.addEventListener('pointermove', onMove);
    bar.addEventListener('pointerup', onEnd);
    bar.addEventListener('pointercancel', onEnd);

    layer.addEventListener(
      'click',
      function (event) {
        if (!moved) return;
        if (event.target === layer) {
          event.stopPropagation();
        }
        moved = false;
      },
      true
    );

    return { reset: reset };
  }

  function pad(value, size) {
    const abs = Math.abs(Math.trunc(value));
    return String(abs).padStart(size, '0');
  }

  function toDms(value, lat) {
    const hemi = lat ? (value >= 0 ? 'N' : 'S') : value >= 0 ? 'E' : 'W';
    const abs = Math.abs(value);
    const deg = Math.floor(abs);
    const minFloat = (abs - deg) * 60;
    const min = Math.floor(minFloat);
    const sec = (minFloat - min) * 60;
    const degSize = lat ? 2 : 3;
    return (
      pad(deg, degSize) +
      '°' +
      pad(min, 2) +
      '′' +
      pad(sec, 2) +
      '.' +
      Math.floor((sec % 1) * 10) +
      '″' +
      hemi
    );
  }

  function nextFix() {
    const roll = Math.random();
    let lat;
    let lng;
    if (roll < 0.08) {
      lat = Math.random() < 0.5 ? 90 : -90;
      lng = Math.random() * 360 - 180;
    } else if (roll < 0.14) {
      lat = 0;
      lng = 0;
    } else {
      lat = Math.random() * 170 - 85;
      lng = Math.random() * 358 - 179;
    }
    return { lat: toDms(lat, true), lng: toDms(lng, false) };
  }

  function scramble(text) {
    return text.replace(/\d/g, function (digit) {
      return Math.random() < 0.55 ? String(Math.floor(Math.random() * 10)) : digit;
    });
  }

  function initGeo() {
    const units = document.querySelectorAll('[data-ch-geo]');
    if (!units.length) return;

    units.forEach(function (unit) {
      const latEl = unit.querySelector('[data-ch-geo-lat]');
      const lngEl = unit.querySelector('[data-ch-geo-lng]');
      if (!latEl || !lngEl) return;

      let fix = nextFix();
      let hunting = false;

      function paint(lat, lng) {
        latEl.textContent = lat;
        lngEl.textContent = lng;
      }

      function hunt() {
        if (reduceMotion) return;
        hunting = true;
        unit.classList.add('is-hunting');
        let frames = 0;
        const max = 7 + Math.floor(Math.random() * 6);
        const tick = window.setInterval(function () {
          frames += 1;
          paint(scramble(fix.lat), scramble(fix.lng));
          if (frames >= max) {
            window.clearInterval(tick);
            fix = nextFix();
            paint(fix.lat, fix.lng);
            hunting = false;
            unit.classList.remove('is-hunting');
            window.setTimeout(hunt, 1800 + Math.random() * 3200);
          }
        }, 55);
      }

      paint(fix.lat, fix.lng);
      if (reduceMotion) return;
      window.setTimeout(hunt, 400 + Math.random() * 900);
    });
  }

  function hexWord() {
    return Math.floor(Math.random() * 0xffff)
      .toString(16)
      .toUpperCase()
      .padStart(4, '0');
  }

  function packet() {
    const bytes = [];
    for (let i = 0; i < 8; i += 1) {
      bytes.push(
        Math.floor(Math.random() * 256)
          .toString(16)
          .toUpperCase()
          .padStart(2, '0')
      );
    }
    return (
      'RX ' +
      hexWord() +
      '  ' +
      bytes.join(' ') +
      '  CHK ' +
      hexWord() +
      '  TTL ' +
      String(32 + Math.floor(Math.random() * 32)).padStart(2, '0') +
      '  SEQ ' +
      hexWord() +
      '  IFACE tun0  PAYLOAD ' +
      hexWord() +
      hexWord()
    );
  }

  function initIntercept() {
    const track = document.querySelector('[data-ch-intercept]');
    if (!track) return;
    const chunks = [];
    for (let i = 0; i < 18; i += 1) chunks.push(packet());
    const line = chunks.join('   ·   ') + '   ·   ';
    track.textContent = line + line;

    if (reduceMotion) return;
    window.setInterval(function () {
      const next = [];
      for (let i = 0; i < 18; i += 1) next.push(packet());
      const rebuilt = next.join('   ·   ') + '   ·   ';
      track.textContent = rebuilt + rebuilt;
    }, 9000);
  }

  function initSig() {
    const nodes = document.querySelectorAll('[data-ch-sig]');
    if (!nodes.length) return;

    function stamp() {
      const now = Math.floor(Date.now() / 1000)
        .toString(16)
        .toUpperCase();
      nodes.forEach(function (node) {
        node.textContent = '0x' + now;
      });
    }

    stamp();
    if (!reduceMotion) window.setInterval(stamp, 1000);
  }

  function initGlitch() {
    if (reduceMotion) return;
    const level = document.documentElement.getAttribute('data-ch-glitch') || 'low';
    if (level === 'off') return;
    const root = document.documentElement;
    const low = level !== 'medium';

    function hit() {
      root.classList.add('is-glitching');
      window.setTimeout(function () {
        root.classList.remove('is-glitching');
      }, low ? 40 + Math.random() * 40 : 90 + Math.random() * 70);
      window.setTimeout(hit, (low ? 9000 : 3500) + Math.random() * (low ? 9000 : 8000));
    }

    window.setTimeout(hit, 2200 + Math.random() * 2400);
  }

  function padClock(value) {
    return String(value).padStart(2, '0');
  }

  function clockStamp() {
    const now = new Date();
    return (
      padClock(now.getMonth() + 1) +
      '.' +
      padClock(now.getDate()) +
      '.' +
      String(now.getFullYear()).slice(-2) +
      ' / ' +
      padClock(now.getHours()) +
      ':' +
      padClock(now.getMinutes()) +
      ':' +
      padClock(now.getSeconds())
    );
  }

  function initClock() {
    const nodes = document.querySelectorAll('[data-ch-clock]');
    if (!nodes.length) return;

    function paint() {
      const stamp = clockStamp();
      nodes.forEach(function (node) {
        node.textContent = stamp;
        node.dataset.chOriginal = stamp;
      });
    }

    paint();
    window.setInterval(paint, 1000);
  }

  function initBoot() {
    const root = document.documentElement;
    if (root.classList.contains('ch-boot-done')) return;
    if (root.classList.contains('shopify-design-mode')) {
      root.classList.add('ch-boot-done');
      return;
    }
    const boot = document.querySelector('[data-ch-boot]');
    if (!boot) {
      root.classList.add('ch-boot-done');
      return;
    }

    const duration = parseInt(boot.getAttribute('data-ch-duration') || '1200', 10);
    const lines = boot.querySelectorAll('[data-ch-boot-line]');
    const step = Math.max(110, Math.floor(duration / Math.max(lines.length, 1)));

    lines.forEach(function (line, index) {
      window.setTimeout(function () {
        line.classList.add('is-on');
      }, index * step);
    });

    window.setTimeout(function () {
      root.classList.add('ch-boot-done');
      try {
        sessionStorage.setItem('ch:boot', '1');
      } catch (err) {}
    }, duration);
  }

  function scrambleHoverValue(text) {
    const glyphs = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#%*';
    return String(text)
      .split('')
      .map(function (ch) {
        if (ch === 'i' || /[\s\/._:\-–—]/.test(ch)) return ch;
        return glyphs.charAt(Math.floor(Math.random() * glyphs.length));
      })
      .join('');
  }

  function initHoverScramble() {
    if (reduceMotion) return;
    if (document.documentElement.getAttribute('data-ch-scramble-enabled') !== 'true') return;

    document.addEventListener(
      'pointerover',
      function (event) {
        const node = event.target && event.target.closest ? event.target.closest('[data-ch-scramble-hover]') : null;
        if (!node || node.dataset.chScrambling === '1') return;
        if (event.relatedTarget && node.contains(event.relatedTarget)) return;
        const original = node.textContent;
        node.dataset.chScrambling = '1';
        let frames = 0;
        const max = 4;
        const tick = window.setInterval(function () {
          frames += 1;
          node.textContent = scrambleHoverValue(original);
          if (frames >= max) {
            window.clearInterval(tick);
            node.textContent = original;
            node.dataset.chScrambling = '';
          }
        }, 28);
      },
      true
    );
  }

  function initWindows() {
    const docLayer = document.querySelector('[data-ch-doc-layer]');
    const dossierLayer = document.querySelector('[data-ch-dossier-layer]');
    if (!docLayer && !dossierLayer) return;

    const docTitle = docLayer && docLayer.querySelector('[data-ch-doc-title]');
    const docBody = docLayer && docLayer.querySelector('[data-ch-doc-body]');
    const dossierTitle = dossierLayer && dossierLayer.querySelector('[data-ch-dossier-title]');
    const dossierBody = dossierLayer && dossierLayer.querySelector('[data-ch-dossier-body]');
    const docClose = docLayer && docLayer.querySelector('[data-ch-doc-close]');
    let docToken = 0;
    const noopDrag = { reset: function () {} };
    const docDrag = docLayer
      ? bindWindowDrag(
          docLayer,
          docLayer.querySelector('.ch-window'),
          docLayer.querySelector('[data-ch-window-drag]')
        )
      : noopDrag;
    const dossierDrag = dossierLayer
      ? bindWindowDrag(
          dossierLayer,
          dossierLayer.querySelector('.ch-window'),
          dossierLayer.querySelector('[data-ch-window-drag]')
        )
      : noopDrag;

    function closePlayer() {
      document.dispatchEvent(new Event('ch:close-player'));
    }

    function closeDossier() {
      closePlayer();
      if (!dossierLayer) return;
      dossierLayer.hidden = true;
      document.body.classList.remove('ch-dossier-open');
      if (dossierBody) dossierBody.replaceChildren();
      if (dossierTitle) dossierTitle.textContent = '';
      dossierDrag.reset();
    }

    function closeDoc() {
      docToken += 1;
      closeDossier();
      if (!docLayer) return;
      docLayer.hidden = true;
      document.body.classList.remove('ch-doc-open');
      if (docBody) docBody.replaceChildren();
      if (docTitle) docTitle.textContent = '';
      docDrag.reset();
    }

    function openDossier(opener) {
      const record = opener.closest('.ch-record');
      const panel = record && record.querySelector('[data-ch-dossier-panel]');
      if (!panel || !dossierBody) return;
      const clone = panel.cloneNode(true);
      clone.hidden = false;
      clone.removeAttribute('hidden');
      if (dossierTitle) {
        dossierTitle.textContent = opener.getAttribute('data-ch-dossier-title') || '';
      }
      dossierBody.replaceChildren();
      while (clone.firstChild) dossierBody.appendChild(clone.firstChild);
      dossierLayer.hidden = false;
      document.body.classList.add('ch-dossier-open');
      dossierDrag.reset();
    }

    function openDoc(link) {
      const href = link.getAttribute('href');
      if (!href || !docBody) return;
      closeDossier();
      const token = (docToken += 1);
      if (docTitle) {
        docTitle.textContent = link.getAttribute('data-ch-doc-title') || '';
      }
      docBody.innerHTML = '<p class="ch-window__status">RETRIEVING FILE…</p>';
      docLayer.hidden = false;
      document.body.classList.add('ch-doc-open');
      docDrag.reset();

      fetch(href, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('doc');
          return response.text();
        })
        .then(function (html) {
          if (token !== docToken) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const panel = parsed.querySelector('[data-ch-doc-panel]');
          if (!panel) {
            window.location.href = href;
            return;
          }
          docBody.replaceChildren(panel.cloneNode(true));
          if (docClose) docClose.focus();
        })
        .catch(function () {
          if (token !== docToken) return;
          window.location.href = href;
        });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ch-doc-close]')) {
        event.preventDefault();
        closeDoc();
        return;
      }
      if (event.target.closest('[data-ch-dossier-close]')) {
        event.preventDefault();
        closeDossier();
        return;
      }
      if (docLayer && event.target === docLayer) {
        closeDoc();
        return;
      }
      if (dossierLayer && event.target === dossierLayer) {
        closeDossier();
        return;
      }

      const dossierOpen = event.target.closest('[data-ch-dossier-open]');
      if (dossierOpen) {
        event.preventDefault();
        openDossier(dossierOpen);
        return;
      }

      const docLink = event.target.closest('a[data-ch-doc]');
      if (!docLink) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openDoc(docLink);
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') return;
        const player = document.querySelector('[data-ch-player]');
        if (player && !player.hidden) {
          event.preventDefault();
          closePlayer();
          return;
        }
        if (dossierLayer && !dossierLayer.hidden) {
          event.preventDefault();
          closeDossier();
          return;
        }
        if (docLayer && !docLayer.hidden) {
          event.preventDefault();
          closeDoc();
        }
      },
      true
    );
  }

  function initMount() {
    const overlay = document.querySelector('[data-ch-mount]');
    if (!overlay) return;

    const cmd = overlay.querySelector('[data-ch-mount-cmd]');
    const duration = parseInt(overlay.getAttribute('data-ch-duration') || '720', 10);
    const handleMap = {
      '': 'INDEX',
      directory: 'ARCHiVE',
      narrative: 'NARRATiVE',
      'music-video': 'MUSiC_ViDEO',
      generative: 'GENERATiVE',
      store: 'PRODUCTS',
      contact: 'CONTACT',
      lore: 'LORE',
      live: 'LiVE',
      cart: 'CART'
    };

    function mountPath(anchor, url) {
      const explicit = anchor.getAttribute('data-ch-mount-path');
      if (explicit) return explicit;
      const parts = url.pathname.replace(/\/+$/, '').split('/');
      const handle = parts[parts.length - 1] || '';
      if (handleMap[handle]) return handleMap[handle];
      if (parts.indexOf('collections') !== -1 || parts.indexOf('products') !== -1) return 'PRODUCTS';
      return handle.replace(/-/g, '_').toUpperCase() || 'ARCHiVE';
    }

    function isArchiveNav(anchor, event) {
      if (!anchor || event.defaultPrevented) return false;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
      if (anchor.target && anchor.target !== '_self') return false;
      if (anchor.hasAttribute('download')) return false;
      if (anchor.hasAttribute('data-ch-no-mount')) return false;
      if (anchor.hasAttribute('data-ch-doc')) return false;
      if (anchor.classList.contains('skip-to-content-link')) return false;
      const raw = anchor.getAttribute('href');
      if (!raw || raw.charAt(0) === '#') return false;
      let url;
      try {
        url = new URL(anchor.href, window.location.href);
      } catch (err) {
        return false;
      }
      if (url.origin !== window.location.origin) return false;
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
      if (url.pathname === window.location.pathname && url.search === window.location.search) {
        return false;
      }
      return url;
    }

    document.addEventListener('click', function (event) {
      const link = event.target.closest('a[href]');
      const url = isArchiveNav(link, event);
      if (!url) return;
      if (reduceMotion) return;

      event.preventDefault();
      if (cmd) cmd.textContent = 'cd /' + mountPath(link, url);
      overlay.hidden = false;
      overlay.classList.add('is-on');
      window.setTimeout(function () {
        window.location.href = url.href;
      }, duration);
    });
  }

  function initTexture() {
    const nodes = document.querySelectorAll('[data-ch-tex]');
    if (!nodes.length) return;
    const words = [
      '0x0F381A',
      'NODE_083',
      'RECOVERY::73%',
      'USR_UNKNOWN',
      'MEDIA_ID 0317',
      'VOL://CH_01',
      'CRC FAILED',
      'FRAME 002931',
      'HASH 918A7C'
    ];

    function spin() {
      nodes.forEach(function (node, index) {
        node.textContent = words[(index + Math.floor(Math.random() * words.length)) % words.length];
      });
    }

    spin();
    if (!reduceMotion) window.setInterval(spin, 7000);
  }

  function initRecover() {
    document.addEventListener(
      'pointerdown',
      function (event) {
        const node = event.target.closest('[data-ch-recover]');
        if (node) node.classList.add('is-resolved');
      },
      { passive: true }
    );
  }

  function youtubeId(url) {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
    );
    return match ? match[1] : '';
  }

  function vimeoId(url) {
    const match = url.match(/vimeo\.com\/(?:video\/|channels\/[^/]+\/)?(\d+)/);
    return match ? match[1] : '';
  }

  function resolvePlayback(src, kind) {
    if (kind === 'image') {
      return { type: 'image', src: src };
    }
    if (kind === 'file' || /\.(mp4|webm|ogg)(\?|$)/i.test(src)) {
      return { type: 'file', src: src };
    }
    if (/\.(jpe?g|png|gif|webp|avif)(\?|$)/i.test(src)) {
      return { type: 'image', src: src };
    }
    const yt = youtubeId(src);
    if (yt) {
      return {
        type: 'iframe',
        src:
          'https://www.youtube-nocookie.com/embed/' +
          yt +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1'
      };
    }
    const vm = vimeoId(src);
    if (vm) {
      return {
        type: 'iframe',
        src: 'https://player.vimeo.com/video/' + vm + '?autoplay=1'
      };
    }
    return { type: 'file', src: src };
  }

  function initPlayer() {
    const player = document.querySelector('[data-ch-player]');
    if (!player) return;

    const stage = player.querySelector('[data-ch-player-stage]');
    const titleEl = player.querySelector('[data-ch-player-title]');
    const closeBtn = player.querySelector('[data-ch-player-close]');
    const win = player.querySelector('[data-ch-player-window]');
    const playerDrag = bindWindowDrag(
      player,
      win,
      player.querySelector('[data-ch-window-drag]')
    );
    let lastFocus = null;

    function frameMarkup(playback) {
      const frame = document.createElement('div');
      frame.className = 'ch-player__frame';
      if (playback.type === 'image') {
        frame.classList.add('ch-player__frame--image');
        const img = document.createElement('img');
        img.src = playback.src;
        img.alt = titleEl.textContent || '';
        frame.appendChild(img);
      } else if (playback.type === 'iframe') {
        const iframe = document.createElement('iframe');
        iframe.src = playback.src;
        iframe.allow =
          'autoplay; fullscreen; picture-in-picture; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.title = titleEl.textContent || 'Video';
        frame.appendChild(iframe);
      } else {
        const video = document.createElement('video');
        video.src = playback.src;
        video.controls = true;
        video.playsInline = true;
        video.autoplay = true;
        frame.appendChild(video);
      }
      return frame;
    }

    function close() {
      player.hidden = true;
      document.body.classList.remove('ch-player-open');
      stage.replaceChildren();
      if (titleEl) titleEl.textContent = '';
      playerDrag.reset();
      if (win) win.classList.remove('ch-window--image');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    function open(trigger) {
      const src = trigger.getAttribute('data-ch-src');
      if (!src) return;
      lastFocus = trigger;
      if (titleEl) titleEl.textContent = trigger.getAttribute('data-ch-title') || '';
      const playback = resolvePlayback(src, trigger.getAttribute('data-ch-kind') || 'url');
      playerDrag.reset();
      if (win) {
        win.classList.toggle('ch-window--image', playback.type === 'image');
      }
      stage.replaceChildren(frameMarkup(playback));
      player.hidden = false;
      document.body.classList.add('ch-player-open');
      if (closeBtn) closeBtn.focus();
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-ch-play]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }
      if (player.hidden) return;
      if (event.target.closest('[data-ch-player-close]')) {
        close();
        return;
      }
      if (event.target === player) close();
    });

    document.addEventListener('ch:close-player', close);
  }

  function initHomeVideo() {
    const video = document.querySelector('.ch-home__stage video, .ch-home__media');
    if (!video || video.tagName !== 'VIDEO') return;

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    if (reduceMotion) {
      video.pause();
      video.removeAttribute('autoplay');
      return;
    }

    const play = function () {
      video.play().catch(function () {});
    };

    play();
    document.addEventListener('touchstart', play, { once: true, passive: true });
  }

  const CORRUPT_POOL = 'ABCDEFGHJKLMNOPQRSTUVWXYZ0123456789#%*<>/\\';
  const HACK_POOL = '0123456789ABCDEF#%*$<>/\\';

  function corruptIndexes(original) {
    const idxs = [];
    for (let i = 0; i < original.length; i += 1) {
      const ch = original.charAt(i);
      if (ch === 'i' || ch === '/' || ch === ':' || ch === '.' || /\s/.test(ch)) continue;
      idxs.push(i);
    }
    return idxs;
  }

  function paintCorrupt(node, pool, count) {
    if (!node) return '';
    const original = node.dataset.chOriginal || node.textContent;
    const idxs = corruptIndexes(original);
    if (!idxs.length) return original;
    const chars = original.split('');
    const n = Math.min(idxs.length, Math.max(1, count));
    const picked = [];
    while (picked.length < n) {
      const at = idxs[Math.floor(Math.random() * idxs.length)];
      if (picked.indexOf(at) === -1) picked.push(at);
    }
    picked.forEach(function (at) {
      chars[at] = pool.charAt(Math.floor(Math.random() * pool.length));
    });
    node.textContent = chars.join('');
    return original;
  }

  function loopCorrupt(nodes, opts) {
    if (reduceMotion || !nodes.length) return;
    if (document.documentElement.getAttribute('data-ch-scramble-enabled') !== 'true') return;

    nodes.forEach(function (node) {
      node.dataset.chOriginal = node.dataset.chOriginal || node.textContent;
    });

    function tick() {
      if (document.hidden) {
        window.setTimeout(tick, opts.gapMax);
        return;
      }
      const hits = opts.hitsMin + Math.floor(Math.random() * (opts.hitsMax - opts.hitsMin + 1));
      for (let i = 0; i < hits; i += 1) {
        const node = nodes[Math.floor(Math.random() * nodes.length)];
        if (opts.skipHover && node.closest && node.closest('a.is-hack, a:hover, a:focus-visible')) continue;
        if (node.dataset.chScrambling === '1') continue;
        const original = paintCorrupt(
          node,
          CORRUPT_POOL,
          opts.charsMin + Math.floor(Math.random() * (opts.charsMax - opts.charsMin + 1))
        );
        window.setTimeout(
          function () {
            if (node.dataset.chScrambling === '1') return;
            if (node.closest && node.closest('a.is-hack')) return;
            node.textContent = node.dataset.chOriginal || original;
          },
          opts.holdMin + Math.random() * (opts.holdMax - opts.holdMin)
        );
      }
      window.setTimeout(tick, opts.gapMin + Math.random() * (opts.gapMax - opts.gapMin));
    }

    window.setTimeout(tick, opts.start);
  }

  function initCrt() {
    const crt = document.querySelector('[data-ch-crt]');
    if (!crt) return;

    const isSplash = crt.classList.contains('ch-crt--splash');
    const nodes = Array.prototype.slice.call(crt.querySelectorAll('[data-ch-crt-text]')).filter(
      function (node) {
        return !node.closest('.ch-dir--index .ch-dir__label') && !node.hasAttribute('data-ch-scramble');
      }
    );

    function drop() {
      if (reduceMotion) return;
      crt.classList.add('is-drop');
      window.setTimeout(function () {
        crt.classList.remove('is-drop');
      }, 480);
      window.setTimeout(drop, 4200 + Math.random() * 5200);
    }

    if (!reduceMotion) {
      window.setTimeout(drop, 3800 + Math.random() * 2400);
    }

    loopCorrupt(
      nodes,
      isSplash
        ? {
            gapMin: 120,
            gapMax: 380,
            hitsMin: 2,
            hitsMax: 5,
            charsMin: 1,
            charsMax: 5,
            holdMin: 40,
            holdMax: 95,
            start: 280,
            skipHover: false
          }
        : {
            gapMin: 280,
            gapMax: 820,
            hitsMin: 1,
            hitsMax: 3,
            charsMin: 1,
            charsMax: 3,
            holdMin: 50,
            holdMax: 120,
            start: 500,
            skipHover: true
          }
    );
  }

  function hackDump() {
    const bytes = [];
    const count = 5 + Math.floor(Math.random() * 4);
    for (let i = 0; i < count; i += 1) {
      bytes.push(
        Math.floor(Math.random() * 256)
          .toString(16)
          .toUpperCase()
          .padStart(2, '0')
      );
    }
    return bytes.join(' ') + '  ' + String(Math.floor(Math.random() * 9999)).padStart(4, '0');
  }

  function initDirectoryGlitch() {
    const labels = Array.prototype.slice.call(
      document.querySelectorAll('.ch-dir--index .ch-dir__label [data-ch-crt-text]')
    );
    loopCorrupt(labels, {
      gapMin: 180,
      gapMax: 640,
      hitsMin: 1,
      hitsMax: 3,
      charsMin: 1,
      charsMax: 4,
      holdMin: 60,
      holdMax: 150,
      start: 420,
      skipHover: true
    });
  }

  function initDirectoryHackHover() {
    const links = document.querySelectorAll('.ch-dir--index .ch-dir__link');
    if (!links.length) return;

    Array.prototype.forEach.call(links, function (link) {
      const path = link.querySelector('[data-ch-dir-path]');
      const hack = link.querySelector('[data-ch-dir-hack]');
      const label = link.querySelector('.ch-dir__label [data-ch-crt-text]');
      if (!path || !hack) return;

      path.dataset.chOriginal = path.dataset.chOriginal || path.textContent;
      let timer = 0;

      function pulse() {
        paintCorrupt(path, HACK_POOL, 2 + Math.floor(Math.random() * 4));
        hack.textContent = hackDump();
        if (label && !reduceMotion) paintCorrupt(label, CORRUPT_POOL, 2 + Math.floor(Math.random() * 3));
        timer = window.setTimeout(pulse, reduceMotion ? 240 : 48);
      }

      function start() {
        if (timer) return;
        link.classList.add('is-hack');
        if (label) label.dataset.chScrambling = '1';
        pulse();
      }

      function stop() {
        window.clearTimeout(timer);
        timer = 0;
        link.classList.remove('is-hack');
        path.textContent = path.dataset.chOriginal;
        hack.textContent = '';
        if (label) {
          label.dataset.chScrambling = '';
          label.textContent = label.dataset.chOriginal || label.textContent;
        }
      }

      link.addEventListener('pointerenter', start);
      link.addEventListener('pointerleave', stop);
      link.addEventListener('focus', start);
      link.addEventListener('blur', stop);
    });
  }

  function initSplashBoot() {
    const boot = document.querySelector('[data-ch-splash-boot]');
    if (!boot) return;

    const lines = boot.querySelectorAll('[data-ch-splash-line]');
    if (!lines.length) return;

    if (reduceMotion) {
      lines.forEach(function (line) {
        line.classList.add('is-on');
      });
      return;
    }

    const duration = parseInt(boot.getAttribute('data-ch-duration') || '2000', 10);
    const step = Math.max(180, Math.floor(duration / Math.max(lines.length, 1)));

    lines.forEach(function (line, index) {
      window.setTimeout(function () {
        line.classList.add('is-on');
      }, index * step);
    });
  }

  function scrambleValue(text) {
    const glyphs = '0123456789ABCDEF#%*<>/\\';
    return String(text)
      .split('')
      .map(function (ch) {
        if (/\s/.test(ch) || ch === '.' || ch === ':' || ch === '-' || ch === '/') return ch;
        return glyphs.charAt(Math.floor(Math.random() * glyphs.length));
      })
      .join('');
  }

  function initTelemetry() {
    if (document.documentElement.getAttribute('data-ch-scramble-enabled') !== 'true') return;

    const nodes = Array.prototype.filter.call(
      document.querySelectorAll('[data-ch-scramble]'),
      function (node) {
        return node !== document.documentElement && node.childElementCount === 0;
      }
    );
    if (!nodes.length) return;

    nodes.forEach(function (node) {
      node.dataset.chOriginal = node.textContent.trim();
    });

    if (reduceMotion) return;

    function burst(node) {
      const original = node.dataset.chOriginal;
      if (!original) return;
      let frames = 0;
      const max = 5 + Math.floor(Math.random() * 7);
      const tick = window.setInterval(function () {
        frames += 1;
        node.textContent = scrambleValue(original);
        if (frames >= max) {
          window.clearInterval(tick);
          node.textContent = original;
        }
      }, 48);
    }

    function loop() {
      burst(nodes[Math.floor(Math.random() * nodes.length)]);
      window.setTimeout(loop, 380 + Math.random() * 900);
    }

    window.setTimeout(loop, 240);
  }

  function initHeaderNav() {
    const header = document.querySelector('.ch-header');
    if (!header) return;

    const toggle = header.querySelector('.ch-header__toggle');
    const tools = header.querySelector('.ch-header__tools');
    const desktop = window.matchMedia('(min-width: 750px)');

    function setOpen(open) {
      header.classList.toggle('is-nav-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function close() {
      setOpen(false);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!header.classList.contains('is-nav-open'));
      });
    }

    if (tools) {
      tools.addEventListener('click', close);
    }

    document.addEventListener('click', function (event) {
      if (desktop.matches) return;
      if (!header.classList.contains('is-nav-open')) return;
      if (header.contains(event.target)) return;
      close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      close();
    });

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', close);
    } else if (typeof desktop.addListener === 'function') {
      desktop.addListener(close);
    }
  }

  function initDossiers() {
    document.addEventListener(
      'toggle',
      function (event) {
        const entry = event.target;
        if (!entry || !entry.matches || !entry.matches('[data-ch-entry]')) return;
        if (!entry.open) return;
        document.querySelectorAll('[data-ch-entry][open]').forEach(function (other) {
          if (other !== entry) other.open = false;
        });
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (document.body.classList.contains('ch-player-open')) return;
      document.querySelectorAll('[data-ch-entry][open]').forEach(function (entry) {
        entry.open = false;
      });
    });
  }

  function initAudio() {
    const audio = document.querySelector('[data-ch-audio]');
    if (!audio) return;

    const decks = document.querySelectorAll('[data-ch-tape]');
    const labels = {
      hold: audio.getAttribute('data-ch-hold') || 'HOLD',
      live: audio.getAttribute('data-ch-live') || 'LIVE',
      mute: audio.getAttribute('data-ch-mute') || 'MUTE',
      wait: audio.getAttribute('data-ch-wait') || 'WAIT'
    };
    const maxVol = Math.max(
      0.05,
      Math.min(1, (parseInt(audio.getAttribute('data-ch-volume'), 10) || 30) / 100)
    );
    let wanted = false;
    let muted = false;
    let ducked = false;
    let fadeTimer = 0;

    try {
      wanted = sessionStorage.getItem('ch:audio') === '1';
      muted = sessionStorage.getItem('ch:audio-mute') === '1';
      const saved = parseFloat(sessionStorage.getItem('ch:audio-t') || '0');
      if (!isNaN(saved) && saved > 0) audio.currentTime = saved;
    } catch (err) {}

    function persist() {
      try {
        sessionStorage.setItem('ch:audio', wanted ? '1' : '0');
        sessionStorage.setItem('ch:audio-mute', muted ? '1' : '0');
        sessionStorage.setItem('ch:audio-t', String(audio.currentTime || 0));
      } catch (err) {}
    }

    function paint() {
      let state = labels.hold;
      let live = false;
      let wait = false;
      let muteClass = false;
      if (wanted && muted) {
        state = labels.mute;
        muteClass = true;
      } else if (wanted && ducked) {
        state = labels.wait;
        wait = true;
      } else if (wanted && !audio.paused) {
        state = labels.live;
        live = true;
      }
      Array.prototype.forEach.call(decks, function (deck) {
        const label = deck.querySelector('[data-ch-tape-state]');
        if (label) label.textContent = state;
        deck.classList.toggle('is-live', live);
        deck.classList.toggle('is-wait', wait);
        deck.classList.toggle('is-mute', muteClass);
        deck.setAttribute('aria-pressed', live ? 'true' : 'false');
      });
    }

    function fadeTo(volume, ms, done) {
      window.clearInterval(fadeTimer);
      if (reduceMotion || ms < 40) {
        audio.volume = volume;
        if (done) done();
        return;
      }
      const from = audio.volume;
      const start = Date.now();
      fadeTimer = window.setInterval(function () {
        const t = Math.min(1, (Date.now() - start) / ms);
        audio.volume = from + (volume - from) * t;
        if (t >= 1) {
          window.clearInterval(fadeTimer);
          audio.volume = volume;
          if (done) done();
        }
      }, 32);
    }

    function playSignal() {
      if (!wanted || muted || ducked) return;
      audio.volume = audio.paused ? 0 : audio.volume;
      const play = audio.play();
      if (play && typeof play.then === 'function') {
        play
          .then(function () {
            fadeTo(maxVol, 420);
            paint();
          })
          .catch(function () {
            paint();
          });
      } else {
        fadeTo(maxVol, 420);
        paint();
      }
    }

    function stopSignal(hard) {
      fadeTo(0, hard ? 0 : 280, function () {
        audio.pause();
        paint();
      });
    }

    function arm() {
      wanted = true;
      persist();
      playSignal();
      paint();
    }

    function setDucked(next) {
      if (ducked === next) return;
      ducked = next;
      if (ducked) stopSignal(false);
      else playSignal();
      paint();
    }

    Array.prototype.forEach.call(decks, function (deck) {
      deck.addEventListener('click', function (event) {
        event.preventDefault();
        if (!wanted) {
          muted = false;
          arm();
          return;
        }
        muted = !muted;
        persist();
        if (muted) stopSignal(false);
        else playSignal();
        paint();
      });
    });

    document.addEventListener(
      'pointerdown',
      function (event) {
        if (wanted) return;
        if (event.target && event.target.closest && event.target.closest('[data-ch-tape]')) return;
        arm();
      },
      true
    );

    window.addEventListener('pagehide', persist);

    const mo = new MutationObserver(function () {
      setDucked(document.body.classList.contains('ch-player-open'));
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    setDucked(document.body.classList.contains('ch-player-open'));

    if (wanted && !muted) playSignal();
    paint();
  }

  initBoot();
  initClock();
  initHoverScramble();
  initWindows();
  initMount();
  initTexture();
  initRecover();
  initGeo();
  initIntercept();
  initSig();
  initGlitch();
  initHeaderNav();
  initHomeVideo();
  initSplashBoot();
  initCrt();
  initDirectoryGlitch();
  initDirectoryHackHover();
  initTelemetry();
  initDossiers();
  initPlayer();
  initAudio();
})();
